import React, { useEffect, useState } from 'react';
import { firestore } from './firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import './GalleryOutput.css';

const GalleryOutput = () => {
  const [mediaItems, setMediaItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const fetchMediaItems = async () => {
      try {
        const galleryCollection = collection(firestore, 'gallery');
        const gallerySnapshot = await getDocs(galleryCollection);
        setMediaItems(gallerySnapshot.docs.map(doc => doc.data()));
      } catch (error) {
        console.error('Error fetching gallery items:', error);
      }
    };

    fetchMediaItems();
  }, []);

  const openModal = (item) => {
    setSelectedItem(item);
  };

  const closeModal = () => {
    setSelectedItem(null);
  };

  return (
    <div className="gallery-container">
      <h2>Gallery</h2>
      {mediaItems.length === 0 ? (
        <p>No media available.</p>
      ) : (
        <div className="gallery-grid">
          {mediaItems.map((item, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openModal(item)}
            >
              {item.mediaType === 'video' ? (
                <video
                  src={item.mediaUrl}
                  className="media"
                  controls
                  loading="lazy"
                />
              ) : (
                <img
                  src={item.mediaUrl}
                  alt={`Media ${index}`}
                  className="media"
                  loading="lazy"
                />
              )}
            </div>
          ))}
        </div>
      )}

      {selectedItem && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            {selectedItem.mediaType === 'video' ? (
              <video
                src={selectedItem.mediaUrl}
                controls
                className="modal-media"
              />
            ) : (
              <img
                src={selectedItem.mediaUrl}
                alt="Selected media"
                className="modal-media"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryOutput;
